import { types } from 'mobx-state-tree';
import KeywordFilterModel from 'apps/find-designers/models/KeywordFilterModel';
import CheckboxFilterModel from 'apps/find-designers/models/CheckboxFilterModel';
import RadioFilterModel from 'apps/find-designers/models/RadioFilterModel';
import GroupedCheckboxFilterModel from 'apps/find-designers/models/GroupedCheckboxFilterModel';
import CollapsibleCheckboxFilterModel from 'apps/find-designers/models/CollapsibleCheckboxFilterModel';
import qs from 'query-string';
import isEmpty from 'lodash.isempty';

const FilterStore = types
    .model('FilterStore', {
        filters: types.array(
            types.union(
                KeywordFilterModel,
                CheckboxFilterModel,
                GroupedCheckboxFilterModel,
                CollapsibleCheckboxFilterModel,
                RadioFilterModel
            )
        ),
    })
    .views(self => ({
        get filtersForQueryString() {
            return self.filters.reduce((acc, filter) => {
                if (filter.valueForQuery) {
                    acc[filter.name] = filter.valueForQuery;
                }

                return acc;
            }, {});
        },

        get selectedFilterOptions() {
            const things = self.filters.reduce((acc, filter) => {
                const newArr = [...acc, ...filter.selectedOptions];

                return newArr;
            }, []);

            return things;
        },

        get currentQueryString() {
            const queryString = `${qs.stringify(self.filtersForQueryString, {
                arrayFormat: 'bracket',
            })}`;
            return queryString.length ? `?${queryString}` : '';
        },

        get activeFilters() {
            return self.filters.reduce((acc, filter) => {
                if (filter.valueForQuery) {
                    if (filter.valueForQuery.length > 0) {
                        acc[filter.name] = filter.valueForQuery;
                    }
                }

                return acc;
            }, {});
        },

        get showStoreFront() {
            for (let i = 0; i < self.filters.length; i++) {
                if (!isEmpty(self.filters[i].valueForQuery)) return false;
            }
            return true;
        },

        isQuerySet(queryString) {
            const params = qs.parse(queryString, { arrayFormat: 'bracket' });

            return self.filters.every(filterGroup => filterGroup.isMatch(params[filterGroup.name]));
        },

        getFilterByName(name) {
            return self.filters.find(element => element.name === name);
        },
    }))
    .actions(self => ({
        setValue(name, value) {
            const filter = self.getFilterByName(name);

            filter.setValue(value);
        },

        clearFilterOption(name, value) {
            const filter = self.getFilterByName(name);
            filter.clear(value);
        },

        reset() {
            self.filters.forEach(filter => {
                filter.reset();
            });
        },

        setFiltersFromQueryString(queryString) {
            const params = qs.parse(queryString, { arrayFormat: 'bracket' });

            self.filters.forEach(filterGroup => {
                filterGroup.setValue(params[filterGroup.name]);
            });
        },
    }));

export default FilterStore;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/stores/FilterStore.js